import { Component } from '@angular/core';

@Component({
  selector: 'app-completed-cases-list',
  templateUrl: './completed-cases-list.component.html',
  styleUrls: ['./completed-cases-list.component.css']
})
export class CompletedCasesListComponent {

}
